// Общий event_id для события Purchase — фронт (пиксель на странице успеха оплаты)
// и бэк (Conversions API из вебхука оплаты) вычисляют его одинаково, на основе
// invoiceId, без обмена сообщениями между собой. Это позволяет Facebook
// дедуплицировать одно и то же событие, пришедшее из двух источников.
export const getPurchaseEventId = (invoiceId: string): string => `purchase_${invoiceId}`;

export const generateFbEventId = (): string =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `fb_${Date.now()}_${Math.random().toString(36).slice(2)}`;

// Обёртка над fbq() — не роняет приложение, если Pixel не загрузился
// (блокировщик рекламы, сбой сети и т.п.), и всегда прокидывает eventID
// для дедупликации с серверными CAPI-событиями.
export const trackFacebookEvent = (eventName: string, eventId: string, params?: Record<string, CustomAny>): void => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return;
  }

  window.fbq('track', eventName, params, { eventID: eventId });
};

export interface FacebookAdvancedMatchingData {
  email?: Nullable<string>;
  phone?: Nullable<string>;
  firstName?: Nullable<string>;
  lastName?: Nullable<string>;
  city?: Nullable<string>;
  // Внешний ID — наш внутренний userId, отдельно от email/телефона
  externalId?: Nullable<string>;
}

// Advanced Matching — привязывает email/телефон к событию на стороне Pixel
// (fbq сам хэширует значения перед отправкой). Без этого InitiateCheckout и
// AddPaymentInfo видны Facebook только по cookie fbp/fbc, что хуже связывает
// их с серверным Purchase (там email/телефон есть всегда, из инвойса).
// Действует на все последующие track()-вызовы до следующего set('userData', ...).
export const setFacebookAdvancedMatching = (userData: FacebookAdvancedMatchingData): void => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return;
  }

  window.fbq('set', 'userData', {
    em: userData.email,
    ph: userData.phone,
    fn: userData.firstName,
    ln: userData.lastName,
    ct: userData.city,
    external_id: userData.externalId,
  });
};
